import { createVolumeAutocompleteFilter } from './common/createVolumeAutocompleteFilter';

export default createVolumeAutocompleteFilter({
  field: 'nodeGroupName',
  groupLabel: 'Node Group',
  mustTypeFirstMessage: 'Start typing node group name',
  // A single space, so opening the section fires `?field=nodeGroupName&pattern=` and shows the
  // full list rather than an empty box. Node-group names share no common prefix the way
  // clusters ('eks') or volumes ('vol-') do, so there is no useful prefix to seed instead.
  // Same shape as SearchVolumeTags, whose 'Name: ' default also sends an empty pattern.
  defaultQuery: ' ',
  allowBlankPattern: true,
  tagVariant: 'node',
  logPrefix: '[NodeGroupFilter]',
});
